import { Injectable } from '@angular/core';
import { AutomataOperationsService, Automation, Context, EntityType, PagedResponse } from '@vendasta/automata';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, debounceTime, map, scan, switchMap, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ManualAutomationService {
  private namespace: string;
  private onlySalesRunnable: boolean;
  private pageSize: number;
  private searchTerm: string;
  private entityTypes: EntityType[];
  private context: Context;

  private clearList = true;

  private nextCursorStorage: string;
  nextCursorTrigger$$: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  private hasMore$$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  hasMore$: Observable<boolean> = this.hasMore$$.asObservable();

  private loading$$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  loading$: Observable<boolean> = this.loading$$.asObservable();

  automations$: Observable<Automation[]>;

  constructor(private readonly operations: AutomataOperationsService) {
    this.automations$ = this.nextCursorTrigger$$.pipe(
      debounceTime(300),
      tap(() => this.loading$$.next(true)),
      switchMap((cursor) =>
        this.operations.searchManualAutomationsWithContext(
          this.searchTerm,
          this.namespace,
          [],
          this.onlySalesRunnable,
          this.entityTypes,
          this.context,
          this.pageSize,
          cursor,
        ),
      ),
      tap((resp: PagedResponse<Automation>) => this.hasMore$$.next(!!resp?.hasMore)),
      tap((resp: PagedResponse<Automation>) => (this.nextCursorStorage = resp?.nextCursor || '')),
      map((resp: PagedResponse<Automation>) => resp?.results || []),
      scan((acc, curr) => {
        if (this.clearList) {
          acc = [];
        }
        return [...acc, ...curr];
      }, []),
      tap(() => this.loading$$.next(false)),
      catchError((err) => {
        console.error(err);
        return throwError(err);
      }),
    );
  }

  init(
    searchTerm: string,
    namespace: string,
    onlySalesRunnable: boolean,
    entityTypes: EntityType[],
    context: Context,
    pageSize: number,
  ): void {
    this.namespace = namespace;
    this.onlySalesRunnable = onlySalesRunnable;
    this.pageSize = pageSize;
    this.searchTerm = searchTerm;
    this.nextCursorStorage = '';
    this.entityTypes = entityTypes ? entityTypes : [EntityType.ENTITY_TYPE_ACCOUNT_GROUP];
    this.context = context;
    this.hasMore$$.next(true);

    this.fetchNextPage();
  }

  fetchNextPage(clearCurrentResults?: boolean): void {
    this.clearList = !!clearCurrentResults;
    this.nextCursorTrigger$$.next(this.nextCursorStorage);
  }

  updateSearchTerm(searchTerm: string): void {
    this.searchTerm = searchTerm;
    this.nextCursorStorage = '';
    this.fetchNextPage(true);
  }
}
